export enum DocumentType {
  StudentId = 'StudentId',
  DoctorsPaper = 'DoctorsPaper',
  StudentStatusVerification = 'StudentStatusVerification',
}
